import { render, staticRenderFns } from "./GoodsUpsertForm.vue?vue&type=template&id=52c4f188&scoped=true"
import script from "./GoodsUpsertForm.vue?vue&type=script&lang=js"
export * from "./GoodsUpsertForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c4f188",
  null
  
)

export default component.exports